/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Types/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Types({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/CsvTxCardFields/Types",
  isInvalid,
  onChange
  
}) {
let dataTxCardFieldTypesCsvIsValidData = fromData.useDataIsValid({ viewPath,
context: 'data',
path: 'tx_card_field_types_csv',
validate: fromHelpers.validate,
required: true,
})
let dataTxCardFieldTypesCsvChangeData = fromData.useDataChange({ viewPath,
context: 'data',
path: 'tx_card_field_types_csv',
})
let dataTxCardFieldTypesCsvNameValueData = fromData.useDataValue({ viewPath,
context: 'data',
path: 'tx_card_field_types_csv.name',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 type="file"
 label="IC1-vaxiom.tx_card_field_types.csv"
 data="data.tx_card_field_types_csv"
 required={true}
 validate="helpers.js validate"
 invalid={!dataTxCardFieldTypesCsvIsValidData}
 onChange={dataTxCardFieldTypesCsvChangeData}
 data="data.tx_card_field_types_csv.name"
 value={dataTxCardFieldTypesCsvNameValueData}
/>
{children}
</React.Fragment>)
}